<div id="success-dialog">
  <h2 mat-dialog-title>Success</h2>
  <mat-dialog-content class="mat-typography">
    <p>{{data.message}}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="true">Done</button>
  </mat-dialog-actions>
</div>
